import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../client";

const BASE_URL = "identity/associate";

export const getAssociates = createAsyncThunk("Associate/list", async () =>
  (await api.get(BASE_URL)).data
);

export const getAssociate = createAsyncThunk("Associate", async (id) =>
  (await api.get(`${BASE_URL}/${id}`)).data
);

export const saveAssociate = createAsyncThunk("Associate/save", async (associate) =>
  (await api.post(BASE_URL, associate)).data
);

export const updateAssociate = createAsyncThunk("Associate/update", async (associate) =>
  (await api.put(`${BASE_URL}/${associate.id}`, associate)).data
);

export const deleteAssociate = createAsyncThunk("Associate/delete", async (id) =>
  (await api.delete(`${BASE_URL}/${id}`)).data
);

const addCases = (builder, thunk, onFulfilled, clearMessage = false) =>
  builder
    .addCase(thunk.pending, (state) => {
      state.isLoading = true;
      if (clearMessage) state.message = "";
    })
    .addCase(thunk.fulfilled, (state, action) => {
      state.isLoading = false;
      onFulfilled(state, action);
    })
    .addCase(thunk.rejected, (state, action) => {
      state.isLoading = false;
      state.message = action.payload;
    });

const initialState = {
  list: [],
  associate: null,
  isLoading: false,
  message: null,
};

const slice = createSlice({
  name: "associates",
  initialState,
  reducers: {
    clearAssociate: (state) => { state.associate = null; },
  },
  extraReducers: (builder) => {
    addCases(builder, getAssociates, (state, action) => { state.list = action.payload.data; });
    addCases(builder, getAssociate,  (state, action) => { state.associate = action.payload.data; });
    addCases(builder, saveAssociate,   (state, action) => { state.message = action.payload.message; }, true);
    addCases(builder, updateAssociate, (state, action) => { state.message = action.payload.message; }, true);
    addCases(builder, deleteAssociate, (state, action) => { state.message = action.payload.message; }, true);
  },
});

export const { clearAssociate } = slice.actions;
export default slice.reducer;
